<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Charles.G.Fournel grew up in a small seaside town in Suffolk, England. He is a divorced, devoted father of two. He started writing short stories at the age of ten and since has expanded his genre to World War II. He has family connections in both the allies and axis during the war. This is the reason for his extended interest in this era. He has grown to have great respect for resistance groups who, without any military experience, took up arms for their country. Other books by Charles.G.Fournel: <em>Rise of the Maquis.</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?701ceb12